import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './screens/LandingPage';
import RegistrationComplete from './screens/RegistrationComplete';
import ForgotPassword from './screens/ForgotPassword';
import ResetPassword from './screens/ResetPassword';
import EmailVerificationSuccess from './screens/EmailVerificationSuccess';
import ResendEmailVerification from './screens/ResendEmailVerification';
import PasswordResetConfirmation from './screens/PasswordResetConfirmation';
import AccountVerificationSuccess from './screens/AccountVerificationSuccess';
import TermsOfUse from './screens/TermsOfUse';
import PrivacyPolicy from './screens/PrivacyPolicy';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/registration-complete" element={<RegistrationComplete />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/email-verification-success" element={<EmailVerificationSuccess />} />
          <Route path="/resend-email-verification" element={<ResendEmailVerification />} />
          <Route path="/password-reset-confirmation" element={<PasswordResetConfirmation />} />
          <Route path="/account-verification-success" element={<AccountVerificationSuccess />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
